module.exports = __webpack_public_path__ + "static/media/ic_home_active.adc44d96.svg";